import React, { Component } from "react";
//import { Container, Col, Row } from '../Grid';
//import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar';
//import placeholder from '../../../assets/images/placeholder.jpg'
import { Link } from "react-router-dom";
import localSegmentSelection from "../../../utils/localSegmentSelecttion";
import "./main_nav.css";
import { isEmpty } from "lodash";

class MainNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsArr: [{ id: "r-" + props.roleId, name: props.roleName }],
      optionVal: props.selected_client,
      ifShowSelection: false,
      clientAdminMode: props.roleId > 1 && props.roleId < 10,
      businessUserMode: props.roleId > 50,
      SystemAdminMode: isNaN(props.selected_client),
      businessAdminMode: props.roleId === 51,
      disabledAllClientsOption: true,
      sltWidth: "50px",
      iframeSrc: undefined,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userId !== this.props.userId) {
      if (!/\/create-internal-account/g.test(this.props.location.path)) {
        this.props.getUserDetail(nextProps.userId);
        if (this.props.loginUserDetail && this.props.loginUserDetail.baroUid)
          this.props.getOptimizeUserDetail();

        //this.props.getUserClients(nextProps.userId)
        this.props.getCurrentUserClients();
      }
    }
    if (nextProps.loginUserDetail !== this.props.loginUserDetail) {
      this.props.getUserAvatar(
        nextProps.loginUserDetail
          ? nextProps.loginUserDetail.avatar
          : this.props.loginUserDetail.avatar,
      );
      if (
        nextProps.loginUserDetail &&
        nextProps.loginUserDetail.baroUid &&
        !this.props.optimizeUserDetail
      ) {
        this.props.getOptimizeUserDetail();
      }
    }
    if (
      typeof nextProps.selected_client === "number" &&
      nextProps.selected_client !== this.props.selected_client
    ) {
      this.props.getClientInfo(nextProps.selected_client);
      this.setState({
        optionVal: nextProps.selected_client,
      });
    }

    if (nextProps.selected_client !== this.props.selected_client) {
      this.props.getDisabledFeatures();

      this.setState({
        clientAdminMode: nextProps.roleId > 1 && nextProps.roleId < 10,
        businessUserMode: nextProps.roleId > 50,
        businessAdminMode: nextProps.roleId === 51,
        SystemAdminMode: isNaN(nextProps.selected_client),
        optionVal: nextProps.selected_client,
      });
    }
  }

  componentWillUnmount() {
    this.setState({
      iframeSrc: undefined,
    });
  }

  handleLogOut() {
    let optimizeHost =
      window.location.hostname.indexOf("audienceanywhere.com") >= 0
        ? "https://optimize-" + window.location.hostname
        : "https://optimize-qa.audienceanywhere.com";
    optimizeHost = optimizeHost.replace("optimize-app", "optimize");

    this.setState({
      iframeSrc: optimizeHost + "?action=logout",
    });
    localSegmentSelection.clearLocalData();
    const { handleLogout } = this.props;
    setTimeout(function () {
      handleLogout();
    }, 2000);
    /*
    setTimeout(function () {
      const optimizeHost =
        window.location.hostname.indexOf("audienceanywhere.com") >= 0
          ? "https://optimize-" + window.location.hostname
          : "https://optimize-qa.audienceanywhere.com";

      window.location = `${optimizeHost}?action=logout`;
    }, 100);*/
  }

  gotoOptimizeSite(subpage) {
    let optimizeHost =
      window.location.hostname.indexOf("audienceanywhere.com") >= 0
        ? "https://optimize-" + window.location.hostname
        : "https://optimize-qa.audienceanywhere.com";
    optimizeHost = optimizeHost.replace("optimize-app", "optimize");
    const token = localStorage.getItem("aa_access_token");
    if (subpage) optimizeHost += "/" + subpage;
    window.location.href = token
      ? subpage
        ? optimizeHost + "?token=" + token.replace("Bearer ", "")
        : optimizeHost +
          "?token=" +
          token.replace("Bearer ", "") +
          "&path=" +
          subpage
      : subpage
      ? optimizeHost + "?path=" + subpage
      : subpage;
  }

  render() {
    const path = this.props.location.path ? this.props.location.path : "";
    const {
      roleId,
      client_info,
      loginUserDetail,
      selected_client,
      optimizeUserDetail,
    } = this.props;
    const hideAudienceTab =
      roleId > 3 && client_info && client_info.subscription.id > 4;
    const hideAAMenu =
      loginUserDetail &&
      loginUserDetail.baroUid &&
      optimizeUserDetail &&
      optimizeUserDetail.aaUser &&
      optimizeUserDetail.aaUser.subscriptionTierId &&
      parseInt(optimizeUserDetail.aaUser.subscriptionTierId, 10) === 5;
    if (this.props.display && this.props.display === "none") return "";
    const showContainer =
      (loginUserDetail && !loginUserDetail.baroUid) ||
      (this.props.optimizeUserDetail &&
        this.props.optimizeUserDetail.aaUser &&
        parseInt(
          this.props.optimizeUserDetail.aaUser.subscriptionTierId,
          10,
        ) !== 5) ||
      (loginUserDetail &&
        loginUserDetail.baroUid &&
        !this.props.optimizeUserDetail &&
        this.props.client_info &&
        parseInt(this.props.client_info.subscriptionTierId, 10) !== 5) ||
      (loginUserDetail &&
        loginUserDetail.baroUid &&
        !this.props.optimizeUserDetail &&
        !this.props.client_info &&
        this.props.selected_client &&
        this.props.selected_client &&
        isNaN(this.props.selected_client) &&
        this.props.selected_client.indexOf("r-") >= 0) ||
      (this.props.loginUserDetail &&
        this.props.loginUserDetail.baroUid &&
        this.props.optimizeUserDetail &&
        parseInt(
          this.props.optimizeUserDetail.aaUser.subscriptionTierId,
          10,
        ) === 5 &&
        (!this.props.disabledFeatures || isEmpty(this.props.disabledFeatures)));
    return (
      <div
        className="navbar no-border-radius"
        style={{
          padding: "0 10%",
          height: "60px",
          display: showContainer ? "block" : "none",
        }}
      >
        <div className="navbar-header mt-10">
          {this.state.iframeSrc && (
            <iframe src={this.state.iframeSrc} width="1" height="1" />
          )}
          <Link to="/" className="navbar-brand ">
            <img
              alt=""
              src="/images/logo.png"
              style={{
                display: "inline-table",
                marginTop: "-12px",
                marginRight: "10px",
                height: "35px",
              }}
            />
          </Link>
          <ul className="nav navbar-nav pull-right visible-xs-block">
            <li>
              <a data-toggle="collapse" data-target="#navbar-mobile">
                <i className="icon-tree5" />
              </a>
            </li>
          </ul>
        </div>

        <div className="navbar-collapse collapse mt-10">
          <ul
            className="nav navbar-nav navbar-right aa-navbar ml-5"
            style={{
              display: /(\/create-internal-account|\/create-client-account|\/create-business-unit-member-account)/g.test(
                this.props.location.path,
              )
                ? "none"
                : "block",
            }}
          >
            <li>
              {/*<a href="#" ><i className="icon-search4" /></a>*/}
              <a className="dropdown-toggle" data-toggle="dropdown">
                <img src={"/images/profile.png"} alt="" />
              </a>
              <ul className="dropdown-menu dropdown-menu-right aa-dropdown-menu">
                <li>
                  <Link className="short" to="/myProfile">
                    {" "}
                    My Profile
                  </Link>
                </li>
                <li className="divider nav-divider" />
                {!hideAAMenu && (
                  <li>
                    <Link
                      className="short"
                      to={"/settings/tags/list?cid=" + selected_client}
                    >
                      Settings
                    </Link>
                  </li>
                )}
                <li className="divider nav-divider" />
                {/*<li><a href="#"> Support</a></li>*/}
                <li className="divider nav-divider" />
                <li>
                  <a
                    className="short"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      this.handleLogOut();
                    }}
                  >
                    Sign Out
                  </a>
                </li>
              </ul>
            </li>
            {/*
						<li>
							<a className="dropdown-toggle" data-toggle="dropdown">
								<img src={"/images/email.png"} alt="" />
							</a>
						</li>
						<li>
							<a className="dropdown-toggle" data-toggle="dropdown">
								<img src={"/images/search.png"} alt="" />
							</a>
						</li>*/}
          </ul>
          <ul
            className="nav navbar-nav navbar-right navbar-nav-material mr-5"
            style={{ marginTop: "0px" }}
          >
            {!hideAAMenu && [
              <li key="nav-dashboard"
                className={
                  path.startsWith("/dashboard")
                    ? "active home-nav-li"
                    : "home-nav-li"
                }
              >
                <Link to={"/dashboard?cid=" + this.props.selected_client}>
                  Dashboard
                </Link>
              </li>,
              <li key="nav-team"
                className={
                  path.startsWith("/employees")
                    ? "active home-nav-li"
                    : "home-nav-li"
                }
                style={{
                  display:
                    this.state.SystemAdminMode &&
                    (this.state.businessAdminMode || this.props.roleId === 1) &&
                    !this.state.clientAdminMode
                      ? "block"
                      : "none",
                }}
              >
                <Link to="/employees">Team</Link>
              </li>,
              <li key="nav-clients"
                className={
                  path.startsWith("/clients")
                    ? "active home-nav-li"
                    : "home-nav-li"
                }
                style={{
                  display:
                    this.state.SystemAdminMode &&
                    this.props.roleId !== 53 &&
                    this.props.roleId !== 5
                      ? "block"
                      : "none",
                }}
              >
                <Link to="/clients">
                  {this.state.businessUserMode ? "Business Units" : "Clients"}
                </Link>
              </li>,
              <li key="nav-audience"
                className={
                  path.startsWith("/segments")
                    ? "active home-nav-li"
                    : "home-nav-li"
                }
                style={{
                  display:
                    !this.state.SystemAdminMode && !hideAudienceTab
                      ? "block"
                      : "none",
                }}
              >
                <Link to="/segments/list/active">Audience </Link>
              </li>,
              <li key="nav-insights"
                className={
                  path.startsWith("/insights")
                    ? "active home-nav-li"
                    : "home-nav-li"
                }
                style={{
                  display:
                    !this.state.SystemAdminMode && this.props.roleId !== 5
                      ? "block"
                      : "none",
                }}
              >
                <a
                  href="#"
                  className="dropdown-toggle legitRipple"
                  data-toggle="dropdown"
                >
                  Insights
                  <span className="caret" />
                </a>
                <ul
                  className="dropdown-menu dropdown-menu-left border-grey aa-dropdown-menu"
                  style={{ marginTop: "5px", borderColor: "#EAEBE8" }}
                >
                  {client_info && client_info.subscriptionTierId === 4 && (
                    <li>
                      <Link
                        className="short"
                        to={"/segment-distribution?cid=" + this.state.optionVal}
                      >
                        Segment Distribution
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link
                      className="short"
                      to={"/insights/summary?cid=" + this.props.selected_client}
                    >
                      Site Analytics
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="short"
                      to={"/insights/audience?cid=" + this.state.optionVal}
                    >
                      Audience Files
                    </Link>
                  </li>
                </ul>
              </li>,
            ]}
            <li key="nav-optimize"
              className="home-nav-li"
              style={{
                display:
                  //this.props.optimizeUserDetail &&
                  this.props.disabledFeatures &&
                  this.props.loginUserDetail &&
                  this.props.loginUserDetail.baroUid
                    ? "block"
                    : "none",
              }}
            >
              <a
                onClick={() => {
                  this.gotoOptimizeSite();
                }}
              >
                Optimize
              </a>
            </li>
            {!hideAAMenu && (
              <li key="nav-campaigns"
                className={
                  path.startsWith("/campaigns")
                    ? "active home-nav-li"
                    : "home-nav-li"
                }
                style={{
                  display: !this.state.SystemAdminMode ? "block" : "none",
                }}
              >
                <Link to={"/campaigns?cid=" + this.props.selected_client}>
                  Campaigns
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  }
}

export default MainNav;



// WEBPACK FOOTER //
// ./src/components/framework/MainNav/index.js